import { addBusinessDays } from './businessDays'

export function generateAutoSubtasks(templates, projectId, projectDepartments, arrivalDate, departureDate) {
  if (!projectId || !arrivalDate || !departureDate || !templates?.length) return []

  const depts = Array.isArray(projectDepartments) ? projectDepartments : []
  const results = []

  for (const template of templates) {
    if (!template.enabled) continue

    if (template.appliesTo === 'departments' && template.departments?.length > 0) {
      if (!template.departments.some(d => depts.includes(d))) continue
    }

    for (const task of (template.tasks ?? [])) {
      if (!task.task_name?.trim()) continue

      const anchorDate = task.anchor === 'departure' ? departureDate : arrivalDate
      // downtime is 1-indexed: 1 = anchor day only, 2 = anchor + 1 prior/following biz day, etc.
      const offset = Math.max(0, (task.downtime ?? 1) - 1)
      let startDate, endDate

      if (task.anchorPosition === 'start') {
        startDate = anchorDate
        endDate   = offset > 0 ? addBusinessDays(anchorDate, offset) : anchorDate
      } else {
        // 'end' — milestone ends on the anchor date
        endDate   = anchorDate
        startDate = offset > 0 ? addBusinessDays(anchorDate, -offset) : anchorDate
      }

      results.push({
        project_id: projectId,
        task_name:  task.task_name.trim(),
        department: task.department || 'MX',
        status:     task.status     || 'Scheduled',
        start_date: startDate,
        end_date:   endDate,
      })
    }
  }

  return results
}
